import request from '@/utils/request'
export function selectOrderManagement(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/orderManagement/selectOrderManagement?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function addTransaction(data) {
    return request({
        url: `api/serviceCenter/transaction/addTransaction`,
        method: 'post',
        data,
    })
}

export function addOrderManagement(data) {
    return request({
        url: `api/serviceCenter/orderManagement/addOrderManagement`,
        method: 'post',
        data,
    })
}
export function updateOrderManagement(data) {
    return request({
        url: `api/serviceCenter/orderManagement/updateOrderManagement`,
        method: 'post',
        data,
    })
}
export function upDateCollection(data) {
    return request({
        url: `api/serviceCenter/collection/upDateCollection`,
        method: 'post',
        data,
    })
}

export function CollectionSelectInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/collection/CollectionSelectInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function selectOrderManagementAmount(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/orderManagement/selectOrderManagementAmount?`,
        method: 'post',
        data,
    })
}

export function bathDeleteOrder(data) {
    return request({
        url: `api/serviceCenter/orderManagement/bathDeleteOrder`,
        method: 'post',
        data,
    })
}

export function automaticAssembly(data) {
    return request({
        url: `api/serviceCenter/orderManagement/automaticAssembly`,
        method: 'post',
        data,
    })
}
export function selectAllCustomer(data) {
    return request({
        url: `api/serviceCenter/customer/selectAllCustomer?access=${data}`,
        method: 'post',
    })
}
export function selectAllUser(data) {
    return request({
        url: `api/serviceCenter/user/selectAllUser?access=${data}`,
        method: 'post',
    })
}
export function selectAllDistribution(data) {
    return request({
        url: `api/serviceCenter/distribution/selectAllDistribution?access=${data}`,
        method: 'post',
    })
}
export function selectAllCollection(data) {
    return request({
        url: `api/serviceCenter/collection/selectAllCollection?access=${data}`,
        method: 'post',
    })
}
export function selectOrderInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/orderInfo/selectOrderInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
    
}
export function getCompany(data) {
    return request({
        url: `api/serviceCenter/orderManagement/getCompany?access=${data}`,
        method: 'post',
    })
}

export function selectOrderCustomer(data) {
    return request({
        url: `api/serviceCenter/customer/selectOrderCustomer`,
        method: 'post',
        data,
    })
}
